import { createNavigation } from '@jd/i18n';

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation({
    locales: ['pl'] as string[],
    defaultLocale: 'pl',
    localePrefix: 'as-needed',
  });
